import { render, staticRenderFns } from "./BusinessApplicationEdit.vue?vue&type=template&id=9e1937ae&scoped=true&"
import script from "./BusinessApplicationEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessApplicationEdit.vue?vue&type=script&lang=js&"
import style0 from "./BusinessApplicationEdit.vue?vue&type=style&index=0&id=9e1937ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1937ae",
  null
  
)

export default component.exports